<template>
  <div :class="iconClassName">
    <rt-icon
      v-if="!loadingPermission"
      :name="icon"
      :img-src="iconSrc"
      :size="iconSize"
    ></rt-icon>
    <rt-icon
      v-else-if="iconSrcNew"
      :name="icon"
      :img-src="iconSrcNew"
      :size="iconSize"
    ></rt-icon>
    <rt-icon
      v-else
      :name="defaultName"
      :size="iconSize"
    ></rt-icon>
  </div>
</template>

<script>
import RtIcon from '../../icon/rtIcon';
import config from '../../../config';
export default {
  name: 'RtHeaderIcon',
  components: {
    RtIcon
  },
  props: {
    icon: {
      type: String,
      default: ''
    },
    iconSrc: {
      type: String,
      default: ''
    },
    iconSize: {
      type: [Number, String],
      default: 32
    },
    bgColor: {
      type: String,
      default: 'warning'
    },
    loadingPermission: {
      // 带权限的图片
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      iconSrcNew: '',
      defaultName: ''
    };
  },
  computed: {
    iconClassName () {
      const className = ['rt-header-icon-wrapper'];
      const themeColor = ['primary', 'primary', 'normal', 'success', 'warning', 'danger', 'info'];
      if (themeColor.includes(this.bgColor)) {
        className.push(`bg-color-${this.bgColor}`);
      }
      return className;
    }
  },
  watch: {
    loadingPermission (val) {
      this.getDefaultName(val);
    }
  },
  mounted () {
    this.getDefaultName(this.loadingPermission);
  },
  methods: {
    getDefaultName (loadingPermission) {
      if (loadingPermission) {
        this.defaultName = config.get().defaultIconName;
        let _this = this;
        rt.getImgUrl && rt.getImgUrl(this.iconSrc).then(res => {
          _this.$nextTick(() => {
            _this.iconSrcNew = res;
          });
        });
      }
    }
  }
};
</script>



// WEBPACK FOOTER //
// rtHeaderIcon.vue?7a1ad41a